<div class="row" *ngIf="!noPlanNeeded || !hideRadioButtons">
  <div class="col-9 m-t-lg">
    <tmo-radio-button
      type="radio"
      name="co-radio_sample1"
      [values]="constant?.SHOP_FOR_A_DEVICE"
      [selectedValue]="selectedRadioBtn"
      (onSelect)="handleRadioClickEvent(false)"
      [id]="'tmo-radio-button-coradiosample1'"
    >
      {{ deviceSectionAEMContent?.shopForADevice }}
    </tmo-radio-button>
  </div>
  <div class="col-9 m-t-md">
    <tmo-radio-button
      type="radio"
      name="co-radio_sample1"
      [values]="constant?.BRING_YOUR_OWN_DEVICE"
      [selectedValue]="selectedRadioBtn"
      (onSelect)="handleRadioClickEvent(true)"
      [id]="'tmo-radio-button-coradiosample1-2'"
    >
      {{ deviceSectionAEMContent?.bringYourOwnDevice }}
    </tmo-radio-button>
  </div>
</div>
<div class="row blade border-t border-b m-t-xl" *ngIf="isBringYourOwnDevice">
  <div class="col-12">
    <a
      href="javascript:void(0)"
      class="row header"
      (click)="navigateToBringYourOwnDevice()"
      id="cta-default-139"
    >
      <div class="col-10 header-container">
        <h6>{{ deviceSectionAEMContent?.bringYourOwnDevice }}</h6>
        <p class="blade-desc">{{ deviceSectionAEMContent?.connectYourDeviceWithLine }}</p>
      </div>
      <span class="carret"> <i class="fa def fa-angle-right"></i></span>
    </a>
  </div>
</div>
<ng-container *ngIf="!isBringYourOwnDevice && imagesData?.length > 0; else noDevicesFound">
  <tmo-product-carousel
    (change)="moveToRoute($event)"
    [maxItems]="'20'"
    [itemsToDisplay]="'3'"
    [useRouteParam]="false"
    [deviceSectionAEMContent]="deviceSectionAEMContent"
    [isPlanFirst]="true"
    [isDeviceCarouselProductSelector]="true"
    [productData]="imagesData"
    [itemsToDisplayOnMobile]="'1'"
  >
  </tmo-product-carousel>
</ng-container>
<ng-template #noDevicesFound>
  <tmo-error-message-detail [errorMessage]="apiErrorMessage"></tmo-error-message-detail>
</ng-template>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
